<app-modal title="LOCATIONS.NEW_LOCATION"
          [loading]="loading"
          (submitClicked)="submit()"
          [closeText]="'CANCEL'"
          [submitText]="'SAVE'"
          >
  <app-address-form (formGroupOutput)="formGroup = $event"
                    [type]="'location'"
                    [showNameField]="true"
                    [showActiveStatus]="false"/>
</app-modal>
